import React from 'react'
import { useTranslation } from 'next-i18next'
import { BankTransferType } from 'src/core/models'
import styles from './DepositDetailsModalContent.module.scss'
import { getDepositDetails, getDepositDetailsList } from './deposit-content.helpers'

interface DepositDetailsModalContentProps {
  deposit: BankTransferType
  code: string
  selectedCountry: 'USA' | 'SPAIN'
}

const DepositDetailsModalContent: React.FC<DepositDetailsModalContentProps> = (props) => {
  const { deposit, code, selectedCountry } = props
  const { t } = useTranslation()
  const bankAccountData = deposit?.kind === 'bank' || typeof deposit.kind === 'undefined'
    ? getDepositDetailsList(code, selectedCountry, t, deposit)
    : getDepositDetails(t, deposit, code)

  return (
    <table className={styles['bank-data']}>
      <tbody>
        {bankAccountData.map((content, idx) => (
          <tr key={idx}>
            <td className='bank-data__key'>
              <strong>{content.label}</strong>
            </td>
            <td className='bank-data__value'>
              {content.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default DepositDetailsModalContent
